export const rwOrders = [
  {
    segmentId: 7028260,
    supOrderRef: 74793524,
    supOrderId: 74793524,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '06.05.2020 0:28',
    checkInDate: '17.07.2020',
    checkOutDate: '31.07.2020',
    cxlStart: '11.07.2020 0:00',
    cxlFee: '2756,57',
    hotelCountryCode: 'MX',
    hotelDestination: 'Cabo San Lucas, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/BCB88CD2-5C4D-420D-9687-4D53D4B91F75.jpeg',
    hotelName: 'Playa Grande Resort & Grand Spa All Inclusive Optional',
    hotelAddress: '1 Playa Solmar',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '2326,22',
    supplier: 'HotelDo',
    smartbook: '198,92',
    rebooker: '183,9',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 7021320,
    supOrderRef: 1662626838,
    supOrderId: 'SI135470',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '30.04.2020 16:13',
    checkInDate: '04.09.2020',
    checkOutDate: '13.09.2020',
    cxlStart: '28.08.2020 0:00',
    cxlFee: '2089,7',
    hotelCountryCode: 'US',
    hotelDestination: 'Girdwood, AK, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/E0F7B150-AFF8-43DF-9A23-63FDA52CEA2A.jpeg',
    hotelName: 'Alyeska Resort',
    hotelAddress: '1000 Arlberg Ave',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1763,46',
    supplier: 'SalTours',
    smartbook: '',
    rebooker: '500,14',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 7000913,
    supOrderRef: '',
    supOrderId: 'Y4CQ3Q',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '10.04.2020 10:34',
    checkInDate: '10.07.2020',
    checkOutDate: '12.07.2020',
    cxlStart: '04.07.2020 0:00',
    cxlFee: '957,08',
    hotelCountryCode: 'US',
    hotelDestination: 'New York City, NY, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/102C053C-0DD1-4CFE-8042-76CFF285C8BC.jpeg',
    hotelName: 'The James New York SoHo',
    hotelAddress: '27 Grand St',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '957,08',
    supplier: 'WelcomeBeds',
    smartbook: '61,79',
    rebooker: '101,35',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6993427,
    supOrderRef: 272261787,
    supOrderId: 272254683,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '01.04.2020 11:42',
    checkInDate: '04.06.2020',
    checkOutDate: '06.06.2020',
    cxlStart: '29.05.2020 0:00',
    cxlFee: 388,
    hotelCountryCode: 'FR',
    hotelDestination: 'Paris, France',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B8951AF4-A722-4571-81FB-8D9083C76B03.jpeg',
    hotelName: 'Citadines Montmartre Paris',
    hotelAddress: '16 Avenue Rachel',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: 388,
    supplier: 'Agoda',
    smartbook: '',
    rebooker: '771,86',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6993133,
    supOrderRef: 16859603,
    supOrderId: 'C03701801',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '01.04.2020 0:09',
    checkInDate: '02.07.2020',
    checkOutDate: '05.07.2020',
    cxlStart: '21.06.2020 0:00',
    cxlFee: '518,8',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/110202D5-6713-41AA-A82D-7B420435C047.jpeg',
    hotelName: 'The Cosmopolitan Of Las Vegas',
    hotelAddress: '3708 Las Vegas Blvd S',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '447,6',
    supplier: 'Miki',
    smartbook: '41,75',
    rebooker: '19,68',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6990986,
    supOrderRef: 272455587,
    supOrderId: 272448475,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '29.03.2020 12:20',
    checkInDate: '25.06.2020',
    checkOutDate: '30.06.2020',
    cxlStart: '18.06.2020 0:00',
    cxlFee: 258,
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/EFC09CE7-11F4-45B7-B20B-477E7E4D4C1D.jpeg',
    hotelName: 'New York New York Hotel & Casino',
    hotelAddress: '3790 Las Vegas Blvd S',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 258,
    supplier: 'Agoda',
    smartbook: '41,72',
    rebooker: '43,63',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6988662,
    supOrderRef: '',
    supOrderId: 'Y4CQDD',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.03.2020 9:04',
    checkInDate: '14.06.2020',
    checkOutDate: '21.06.2020',
    cxlStart: '08.06.2020 0:00',
    cxlFee: 1239,
    hotelCountryCode: 'US',
    hotelDestination: 'San Francisco, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/83B1A129-32EF-438D-8D71-7C07EA3CA753.jpeg',
    hotelName: 'Holiday Inn Golden Gateway',
    hotelAddress: '1500 Van Ness Ave',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 1239,
    supplier: 'WelcomeBeds',
    smartbook: '223,42',
    rebooker: '130,78',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6985765,
    supOrderRef: '',
    supOrderId: 248128,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '24.03.2020 6:09',
    checkInDate: '19.06.2020',
    checkOutDate: '22.06.2020',
    cxlStart: '11.06.2020 0:00',
    cxlFee: '621,27',
    hotelCountryCode: 'US',
    hotelDestination: 'Anaheim, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/7938062A-5423-48D4-B0F3-8F2A72536EE1.jpeg',
    hotelName: 'Hilton Anaheim',
    hotelAddress: '777 W Convention Way',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '621,27',
    supplier: 'Nuitee',
    smartbook: '150,24',
    rebooker: '103,49',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6985337,
    supOrderRef: 6993201,
    supOrderId: 6950534,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '23.03.2020 21:18',
    checkInDate: '07.07.2020',
    checkOutDate: '10.07.2020',
    cxlStart: '28.06.2020 0:00',
    cxlFee: '334,55',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D3FD27A7-6364-45EF-B1EA-BF3B4825C0CE.jpeg',
    hotelName: 'Mandalay Bay Resort And Casino',
    hotelAddress: '3950 Las Vegas Blvd S',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '290,75',
    supplier: 'Carsolize',
    smartbook: '52,13',
    rebooker: '14,64',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6975102,
    supOrderRef: 'GO16848840-18266214-A(GI)',
    supOrderId: 18266214,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '17.03.2020 1:37',
    checkInDate: '26.04.2020',
    checkOutDate: '01.05.2020',
    cxlStart: '20.04.2020 0:00',
    cxlFee: '1313,31',
    hotelCountryCode: 'US',
    hotelDestination: 'Boston, MA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/44DC0C56-4751-4054-A8F5-9A32B5E6DBD6.jpeg',
    hotelName: 'Copley Square Hotel',
    hotelAddress: '47 Huntington Ave',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1313,31',
    supplier: 'Go Global',
    smartbook: '',
    rebooker: '482,77',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6972346,
    supOrderRef: '',
    supOrderId: 'Y4CKV9',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '15.03.2020 21:02',
    checkInDate: '17.04.2020',
    checkOutDate: '20.04.2020',
    cxlStart: '05.04.2020 0:00',
    cxlFee: '211,82',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/AC4F5678-138E-4819-B631-FE5038CCBF15.jpeg',
    hotelName: 'Westgate Las Vegas Resort & Casino',
    hotelAddress: '3000 Paradise Road',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 185,
    supplier: 'WelcomeBeds',
    smartbook: '47,75',
    rebooker: '40,54',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6968233,
    supOrderRef: '256-5085316',
    supOrderId: 1001225182,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '14.03.2020 15:31',
    checkInDate: '03.07.2020',
    checkOutDate: '05.07.2020',
    cxlStart: '26.06.2020 0:00',
    cxlFee: '302,68',
    hotelCountryCode: 'US',
    hotelDestination: 'Phoenix, AZ, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/51B3CCB0-25AD-4248-81EA-BB5194D7B21D.jpeg',
    hotelName: 'Pointe Hilton Squaw Peak Resort',
    hotelAddress: '7677 N 16Th St',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '263,36',
    supplier: 'Tourico',
    smartbook: '71,47',
    rebooker: '10,77',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6967715,
    supOrderRef: '',
    supOrderId: '619635220X',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '14.03.2020 10:16',
    checkInDate: '22.04.2020',
    checkOutDate: '26.04.2020',
    cxlStart: '19.04.2020 0:00',
    cxlFee: '279,73',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/62AFC98C-1251-4636-B42E-8EC3F4DF26B6.jpeg',
    hotelName: 'Luxor Hotel and Casino',
    hotelAddress: '3900 S. Las Vegas Blvd',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '279,73',
    supplier: 'Bonotel',
    smartbook: '93,84',
    rebooker: '52,29',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6965981,
    supOrderRef: 'TF5992851',
    supOrderId: 'TF5992851',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '13.03.2020 22:48',
    checkInDate: '08.08.2020',
    checkOutDate: '12.08.2020',
    cxlStart: '02.08.2020 0:00',
    cxlFee: '1136,01',
    hotelCountryCode: 'MX',
    hotelDestination: 'Mazatlan, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5D04BA04-470C-4949-9E66-5B573C9A6777.jpeg',
    hotelName: 'Riu Emerald Bay All Inclusive',
    hotelAddress: 'Calzada Camaron Sabalo',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '1136,01',
    supplier: 'Hotelston',
    smartbook: '',
    rebooker: '220,86',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6965890,
    supOrderRef: '',
    supOrderId: 'DHB200314091345909',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '13.03.2020 22:24',
    checkInDate: '21.08.2020',
    checkOutDate: '24.08.2020',
    cxlStart: '15.08.2020 0:00',
    cxlFee: '378,86',
    hotelCountryCode: 'GB',
    hotelDestination: 'Telford, United Kingdom',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D7D4EE28-1A45-4E2C-B383-F77C789994B5.jpeg',
    hotelName: 'Ramada Telford Ironbridge',
    hotelAddress: 'Forgegate',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '378,86',
    supplier: 'DidaTravel',
    smartbook: '',
    rebooker: '348,99',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6963067,
    supOrderRef: '281-82367',
    supOrderId: '1,5032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '13.03.2020 0:50',
    checkInDate: '23.09.2020',
    checkOutDate: '05.10.2020',
    cxlStart: '04.09.2020 0:00',
    cxlFee: '5194,36',
    hotelCountryCode: 'MU',
    hotelDestination: 'Poste De Flacq, Mauritius',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D7D7A871-979B-4219-BFDF-A8D01619523D.jpeg',
    hotelName: 'Constance Prince Maurice',
    hotelAddress: 'Choisy Road',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '5194,36',
    supplier: 'Hotelbeds',
    smartbook: '73,32',
    rebooker: '171,25',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6960414,
    supOrderRef: 'b4e30b45-5500-4758-acd7-0a990226447a',
    supOrderId: 371032620,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '12.03.2020 3:01',
    checkInDate: '18.06.2020',
    checkOutDate: '25.06.2020',
    cxlStart: '04.06.2020 0:00',
    cxlFee: '10845,68',
    hotelCountryCode: 'GR',
    hotelDestination: 'Mykonos, Greece',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/F9885854-6BF3-4716-901D-A3B0786CFA35.jpeg',
    hotelName: 'Santa Marina a Luxury Collection Resort Mykonos',
    hotelAddress: 'Ornos Bay',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '10845,68',
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '571,54',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6959451,
    supOrderRef: 30340621,
    supOrderId: 6076577,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 21:43',
    checkInDate: '24.10.2020',
    checkOutDate: '28.10.2020',
    cxlStart: '11.10.2020 0:00',
    cxlFee: 1005,
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B626F360-BBD0-4088-B762-BF8FB50EAB21.jpeg',
    hotelName: 'Encore at Wynn Las Vegas',
    hotelAddress: '3121 Las Vegas Blvd',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: 1005,
    supplier: 'AmericanToursInternational',
    smartbook: '',
    rebooker: '1073,38',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6958528,
    supOrderRef: 'a4731f01-f92e-456c-8dce-89a4f44974c9',
    supOrderId: 122853205,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 15:46',
    checkInDate: '12.06.2020',
    checkOutDate: '15.06.2020',
    cxlStart: '06.06.2020 0:00',
    cxlFee: 609,
    hotelCountryCode: 'DE',
    hotelDestination: 'Leipzig, Germany',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/0AC8B3B4-D5FE-4929-8438-1261BD8FF926.jpeg',
    hotelName: 'FELIX Suiten im Lebendigen Haus am Augustusplatz',
    hotelAddress: 'Augustusplatz 1 3',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: 609,
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '188,22',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6958526,
    supOrderRef: '8ddfce4c-cb56-410e-854b-d4fdce637310',
    supOrderId: 826837603,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 15:45',
    checkInDate: '11.04.2020',
    checkOutDate: '13.04.2020',
    cxlStart: '06.04.2020 0:00',
    cxlFee: '374,45',
    hotelCountryCode: 'NL',
    hotelDestination: 'Amsterdam, Netherlands',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/3DF0B76E-2336-4041-B75C-4D7198497EAE.jpeg',
    hotelName: 'Hotel Luxer',
    hotelAddress: 'Warmoesstraat 11',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '374,45',
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '317,22',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6958382,
    supOrderRef: 35708565,
    supOrderId: 31831328,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 14:26',
    checkInDate: '28.03.2020',
    checkOutDate: '31.03.2020',
    cxlStart: '21.03.2020 0:00',
    cxlFee: '502,1',
    hotelCountryCode: 'US',
    hotelDestination: 'New Orleans, LA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/A24B68BA-699E-44CA-B974-5DE7B1F3C761.jpeg',
    hotelName: 'Hilton New Orleans Riverside',
    hotelAddress: '2 Poydras St',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '438,5',
    supplier: 'Hotusa',
    smartbook: '-17,57',
    rebooker: '139,36',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6958284,
    supOrderRef: 1239428,
    supOrderId: 1675573,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 13:37',
    checkInDate: '19.12.2020',
    checkOutDate: '24.12.2020',
    cxlStart: '11.12.2020 0:00',
    cxlFee: 1388,
    hotelCountryCode: 'US',
    hotelDestination: 'New York City, NY, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/AB19CCD9-B37B-4903-BD27-9B61011B2D1E.jpeg',
    hotelName: 'The Knickerbocker Hotel',
    hotelAddress: '6 Times Square',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: 1388,
    supplier: 'Olympia',
    smartbook: '',
    rebooker: '331,28',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6957794,
    supOrderRef: '',
    supOrderId: 242575,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.03.2020 8:01',
    checkInDate: '29.04.2020',
    checkOutDate: '02.05.2020',
    cxlStart: '23.04.2020 0:00',
    cxlFee: '699,88',
    hotelCountryCode: 'US',
    hotelDestination: 'San Diego, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/CBFEDCDB-5EC4-4FD1-BFC0-F80199C1CA49.jpeg',
    hotelName: 'InterContinental San Diego',
    hotelAddress: '901 Bayfront Court',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '699,88',
    supplier: 'Nuitee',
    smartbook: '50,85',
    rebooker: '33,42',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6951785,
    supOrderRef: 'T597BK',
    supOrderId: '1,4032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '09.03.2020 12:38',
    checkInDate: '27.03.2020',
    checkOutDate: '04.04.2020',
    cxlStart: '19.03.2020 0:00',
    cxlFee: 1620,
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/110202D5-6713-41AA-A82D-7B420435C047.jpeg',
    hotelName: 'The Cosmopolitan Of Las Vegas',
    hotelAddress: '3708 Las Vegas Blvd S',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 1620,
    supplier: 'World2Meet',
    smartbook: '178,14',
    rebooker: '325,31',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6950667,
    supOrderRef: '',
    supOrderId: 'DHB200313081704502',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '09.03.2020 1:19',
    checkInDate: '31.03.2020',
    checkOutDate: '03.04.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: '228,3',
    hotelCountryCode: 'JP',
    hotelDestination: 'Kyoto, Japan',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/C9A41D95-5443-4C03-A651-47090FB04976.jpeg',
    hotelName: 'Hotel Gracery Kyoto Sanjo',
    hotelAddress: '420 Sakuranocho Nakagyo Ku',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '228,3',
    supplier: 'DidaTravel',
    smartbook: '',
    rebooker: '680,62',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6948658,
    supOrderRef: 'e334cb77-5e32-44d8-a20e-c2093d5bc402',
    supOrderId: 687697449,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '08.03.2020 11:40',
    checkInDate: '01.04.2020',
    checkOutDate: '06.04.2020',
    cxlStart: '21.03.2020 0:00',
    cxlFee: '259,95',
    hotelCountryCode: 'ES',
    hotelDestination: 'Barcelona, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5AB838EE-77BB-41BA-A32F-23EB4C1BF86F.jpeg',
    hotelName: 'Hotel Exe Mitre',
    hotelAddress: 'Carrer De Bertran 9 15',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '259,95',
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '500,74',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6946193,
    supOrderRef: '',
    supOrderId: 242310,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '07.03.2020 19:30',
    checkInDate: '27.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '22.03.2020 0:00',
    cxlFee: '522,4',
    hotelCountryCode: 'US',
    hotelDestination: 'Atlantic, NJ, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/A0502646-30E0-4430-B9B4-4E4F01D3708F.jpeg',
    hotelName: 'Hard Rock Hotel & Casino Atlantic City',
    hotelAddress: '1000 Boardwalk',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '522,4',
    supplier: 'Nuitee',
    smartbook: '43,08',
    rebooker: '120,3',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6941688,
    supOrderRef: 272198279,
    supOrderId: 272191187,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '06.03.2020 17:37',
    checkInDate: '29.07.2020',
    checkOutDate: '02.08.2020',
    cxlStart: '15.06.2020 0:00',
    cxlFee: '504,52',
    hotelCountryCode: 'ES',
    hotelDestination: 'Lloret De Mar, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/6E5B2A0B-28F8-4EC8-9833-E031F9642A44.jpeg',
    hotelName: 'htop Royal Star & SPA',
    hotelAddress: 'C Vila De Blanes 70',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '504,52',
    supplier: 'Agoda',
    smartbook: '',
    rebooker: '1253,57',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6929717,
    supOrderRef: 'Z13S2L',
    supOrderId: '1,3032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '06.03.2020 4:54',
    checkInDate: '03.04.2020',
    checkOutDate: '09.04.2020',
    cxlStart: '26.03.2020 0:00',
    cxlFee: '1267,56',
    hotelCountryCode: 'US',
    hotelDestination: 'Anaheim, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B9D3D123-8E6E-4A4F-946D-3BADDF847BFB.jpeg',
    hotelName: 'DoubleTree Suites by Hilton Anaheim Rsrt Conv Cntr',
    hotelAddress: '2085 S Harbor Blvd',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 1074,
    supplier: 'World2Meet',
    smartbook: '107,58',
    rebooker: '132,64',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6927892,
    supOrderRef: 'po6smuplhqzyvimfbvkrksciuq',
    supOrderId: 'GRN-202003-294140',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '05.03.2020 20:02',
    checkInDate: '10.04.2020',
    checkOutDate: '12.04.2020',
    cxlStart: '04.04.2020 0:00',
    cxlFee: '686,65',
    hotelCountryCode: 'BR',
    hotelDestination: 'Mata De Sao Joao, Brasil',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/206A9BDB-76B1-4C81-B497-1C7DA3815425.jpeg',
    hotelName: 'Grand Palladium ImbassaÃ­ Resort & Spa All Inclusive',
    hotelAddress: 'Rodovia Ba 099 Km 65 S/N Linha Verde',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '686,65',
    supplier: 'GRNconnect',
    smartbook: '99,18',
    rebooker: '40,82',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6923032,
    supOrderRef: 'mdqqa7c3nq74j5qjksuhi5fyte',
    supOrderId: 'GRN-202003-292788',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '04.03.2020 17:29',
    checkInDate: '27.03.2020',
    checkOutDate: '30.03.2020',
    cxlStart: '19.03.2020 0:00',
    cxlFee: '773,87',
    hotelCountryCode: 'US',
    hotelDestination: 'Washington, DC, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/922D7287-79FD-472A-B2D6-E0983D793235.jpeg',
    hotelName: 'Holiday Inn Washington Capitol',
    hotelAddress: '550 C St Sw',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '701,97',
    supplier: 'GRNconnect',
    smartbook: '61,65',
    rebooker: '115,32',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6920828,
    supOrderRef: '1,3062E+17',
    supOrderId: 'SH9904938',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '04.03.2020 3:34',
    checkInDate: '25.09.2020',
    checkOutDate: '29.09.2020',
    cxlStart: '14.09.2020 0:00',
    cxlFee: 947,
    hotelCountryCode: 'US',
    hotelDestination: 'New York City, NY, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/F5829447-E5AB-4703-99EB-4E8D1BBC73A5.jpeg',
    hotelName: 'Fitzpatrick Grand Central',
    hotelAddress: '141 East 44Th Street',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: 947,
    supplier: 'SunHotels',
    smartbook: '',
    rebooker: '463,71',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6920389,
    supOrderRef: 'H339RN',
    supOrderId: '6,03202E+16',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '04.03.2020 1:03',
    checkInDate: '20.03.2020',
    checkOutDate: '22.03.2020',
    cxlStart: '11.03.2020 0:00',
    cxlFee: 561,
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/061EDDE9-F17D-496A-A3FD-77B9A0020F14.jpeg',
    hotelName: 'The Venetian Resort Las Vegas',
    hotelAddress: '3355 Las Vegas Blvd S',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: 561,
    supplier: 'Bookohotel',
    smartbook: '',
    rebooker: '483,98',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6920324,
    supOrderRef: '',
    supOrderId: 'DHB200312082859453',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '04.03.2020 0:36',
    checkInDate: '12.04.2020',
    checkOutDate: '16.04.2020',
    cxlStart: '06.04.2020 0:00',
    cxlFee: '227,04',
    hotelCountryCode: 'PT',
    hotelDestination: 'Lisbon, Portugal',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/65CBA70C-7604-4CB2-9C19-EDF4ABCCC8A1.jpeg',
    hotelName: 'Hotel Alif Campo Pequeno',
    hotelAddress: 'Avenida Joao Xxi, 80',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '227,04',
    supplier: 'DidaTravel',
    smartbook: '',
    rebooker: '471,27',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6919468,
    supOrderRef: 'TL89579282',
    supOrderId: 'TL89579282',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '03.03.2020 20:42',
    checkInDate: '04.07.2020',
    checkOutDate: '11.07.2020',
    cxlStart: '13.05.2020 0:00',
    cxlFee: '2224,29',
    hotelCountryCode: 'MX',
    hotelDestination: 'Playa Del Carmen, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/60DEC558-FA58-46AD-8FF2-F2E155BC2D3A.jpeg',
    hotelName: 'Occidental at Xcaret Destination All Inclusive',
    hotelAddress: 'Carretera Federal 307 Km 282',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '2224,29',
    supplier: 'Travellanda',
    smartbook: '',
    rebooker: '721,73',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6914261,
    supOrderRef: '',
    supOrderId: 'Y4CMZ3',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '02.03.2020 15:55',
    checkInDate: '21.05.2020',
    checkOutDate: '26.05.2020',
    cxlStart: '16.05.2020 0:00',
    cxlFee: '950,74',
    hotelCountryCode: 'US',
    hotelDestination: 'Boston, MA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/1251F198-B51A-4DF0-B4C0-909AB8C327A3.jpeg',
    hotelName: 'Midtown Hotel',
    hotelAddress: '220 Huntington Avenue',
    star: 2,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '859,7',
    supplier: 'WelcomeBeds',
    smartbook: '45,65',
    rebooker: '72,43',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6912937,
    supOrderRef: '256-5064517',
    supOrderId: '7,03202E+16',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '02.03.2020 7:17',
    checkInDate: '07.04.2020',
    checkOutDate: '09.04.2020',
    cxlStart: '31.03.2020 0:00',
    cxlFee: '322,43',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/3BBAEBE7-189A-4081-A95C-16DD961CACC3.jpeg',
    hotelName: 'Aria Resort & Casino',
    hotelAddress: '3730 Las Vegas Blvd. South',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '278,06',
    supplier: 'Hotelbeds',
    smartbook: '46,9',
    rebooker: '89,52',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6908043,
    supOrderRef: 6957274,
    supOrderId: 6914736,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '01.03.2020 0:43',
    checkInDate: '22.03.2020',
    checkOutDate: '27.03.2020',
    cxlStart: '15.03.2020 0:00',
    cxlFee: '1411,94',
    hotelCountryCode: 'US',
    hotelDestination: 'Palm Springs, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/311336A1-9CE0-44C2-B3E8-8EEBB194344B.jpeg',
    hotelName: 'Ace Hotel and Swim Club Palm Springs',
    hotelAddress: '701 East Palm Canyon',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '1411,94',
    supplier: 'Carsolize',
    smartbook: '167,83',
    rebooker: '155,04',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6897296,
    supOrderRef: 'pir543k2gs5dl4poivim6qxcnq',
    supOrderId: 'GRN-202003-291239',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 22:52',
    checkInDate: '17.03.2020',
    checkOutDate: '25.03.2020',
    cxlStart: '09.03.2020 0:00',
    cxlFee: '675,81',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/AC4F5678-138E-4819-B631-FE5038CCBF15.jpeg',
    hotelName: 'Westgate Las Vegas Resort & Casino',
    hotelAddress: '3000 Paradise Road',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '675,81',
    supplier: 'GRNconnect',
    smartbook: '',
    rebooker: '1096,61',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6897254,
    supOrderRef: 35753439,
    supOrderId: 31920265,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 22:41',
    checkInDate: '21.09.2020',
    checkOutDate: '28.09.2020',
    cxlStart: '13.09.2020 0:00',
    cxlFee: '2908,16',
    hotelCountryCode: 'CA',
    hotelDestination: 'Quebec, QC, Canada',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2F135FF3-7999-4C7D-A9BF-DD6182C94285.jpeg',
    hotelName: 'Fairmont Le Chateau Frontenac',
    hotelAddress: '1 Rue Des Carrieres',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '2326,53',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '521,11',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6897018,
    supOrderRef: 'TF5990197',
    supOrderId: 'TF5990197',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 21:44',
    checkInDate: '23.11.2020',
    checkOutDate: '28.11.2020',
    cxlStart: '09.11.2020 0:00',
    cxlFee: '829,86',
    hotelCountryCode: 'MX',
    hotelDestination: 'Mazatlan, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B265E9C9-F2CC-4BE3-95B9-5B1A7EE81D13.jpeg',
    hotelName: 'El Cid Granada Hotel & Country Club',
    hotelAddress: 'Avenida Camaron Sabalo S/N',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '829,86',
    supplier: 'Hotelston',
    smartbook: '81,47',
    rebooker: '63,59',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6896990,
    supOrderRef: 'TF5990196',
    supOrderId: 'TF5990196',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 21:38',
    checkInDate: '23.11.2020',
    checkOutDate: '28.11.2020',
    cxlStart: '09.11.2020 0:00',
    cxlFee: '829,86',
    hotelCountryCode: 'MX',
    hotelDestination: 'Mazatlan, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B265E9C9-F2CC-4BE3-95B9-5B1A7EE81D13.jpeg',
    hotelName: 'El Cid Granada Hotel & Country Club',
    hotelAddress: 'Avenida Camaron Sabalo S/N',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '829,86',
    supplier: 'Hotelston',
    smartbook: '81,47',
    rebooker: '56,08',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6896495,
    supOrderRef: 1231536,
    supOrderId: 1661647,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 20:11',
    checkInDate: '21.07.2020',
    checkOutDate: '25.07.2020',
    cxlStart: '26.06.2020 0:00',
    cxlFee: '845,62',
    hotelCountryCode: 'MX',
    hotelDestination: 'Nuevo Vallarta, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/C176D3F9-16B5-454F-8D55-BD41A9DF4CAD.jpeg',
    hotelName: 'Marival Emotions Resort & Suites All Inclusive',
    hotelAddress: 'Blvd. Nuevo Vallarta Y Paseo Cocoteros',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '845,62',
    supplier: 'Olympia',
    smartbook: '55,87',
    rebooker: '20,9',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6896268,
    supOrderRef: 35611343,
    supOrderId: 31728353,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 19:17',
    checkInDate: '29.04.2020',
    checkOutDate: '04.05.2020',
    cxlStart: '26.03.2020 0:00',
    cxlFee: '3878,05',
    hotelCountryCode: 'JM',
    hotelDestination: 'Ocho Rios, Jamaica',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/94F7D684-9F68-4D1C-8435-6200051220A4.jpeg',
    hotelName: 'Beaches Ocho Rios A Spa Golf & Waterpark Resort',
    hotelAddress: 'P.O. Box 63',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '3878,05',
    supplier: 'Hotusa',
    smartbook: '302,74',
    rebooker: '863,82',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6896118,
    supOrderRef: 'LONF205842',
    supOrderId: 'LONF205842',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 18:40',
    checkInDate: '28.04.2020',
    checkOutDate: '30.04.2020',
    cxlStart: '21.04.2020 0:00',
    cxlFee: '171,86',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/20466B84-D497-44D4-B594-A81BDA01671C.jpeg',
    hotelName: 'MGM Grand Hotel & Casino',
    hotelAddress: '3799 Las Vegas Blvd S',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '150,38',
    supplier: 'RTS',
    smartbook: '',
    rebooker: '66,38',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895982,
    supOrderRef: 6953544,
    supOrderId: 6911019,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 18:09',
    checkInDate: '28.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '19.03.2020 0:00',
    cxlFee: 132,
    hotelCountryCode: 'ES',
    hotelDestination: 'Jerez De La Frontera, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/98686C5A-BAD5-449C-984B-01E65157575F.jpeg',
    hotelName: 'Hotel Exe Guadalete',
    hotelAddress: 'Avenida Duque De Abrantes 84',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 132,
    supplier: 'Carsolize',
    smartbook: '',
    rebooker: '25,54',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6895746,
    supOrderRef: 1241353130,
    supOrderId: 717606028,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 17:14',
    checkInDate: '03.07.2020',
    checkOutDate: '05.07.2020',
    cxlStart: '13.06.2020 0:00',
    cxlFee: '419,42',
    hotelCountryCode: 'MX',
    hotelDestination: 'Playa Del Carmen, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/40787A66-E75A-4099-9C42-3F9DA7AD4421.jpeg',
    hotelName: 'Ocean Riviera Paradise All Inclusive',
    hotelAddress: 'Crta. Federal Cancún Chetumal Km 296',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '419,42',
    supplier: 'Smyrooms',
    smartbook: '',
    rebooker: '75,66',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895722,
    supOrderRef: 1240570329,
    supOrderId: 717606016,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 17:10',
    checkInDate: '03.07.2020',
    checkOutDate: '05.07.2020',
    cxlStart: '13.06.2020 0:00',
    cxlFee: '335,54',
    hotelCountryCode: 'MX',
    hotelDestination: 'Playa Del Carmen, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/40787A66-E75A-4099-9C42-3F9DA7AD4421.jpeg',
    hotelName: 'Ocean Riviera Paradise All Inclusive',
    hotelAddress: 'Crta. Federal Cancún Chetumal Km 296',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '335,54',
    supplier: 'Smyrooms',
    smartbook: '',
    rebooker: '48,78',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895597,
    supOrderRef: 35717169,
    supOrderId: 31841804,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 16:36',
    checkInDate: '27.10.2020',
    checkOutDate: '02.11.2020',
    cxlStart: '19.10.2020 0:00',
    cxlFee: '1668,25',
    hotelCountryCode: 'SG',
    hotelDestination: 'Singapore, Singapore',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/089D8887-C612-4BE4-897A-DEDC31880B64.jpeg',
    hotelName: 'Grand Park Orchard',
    hotelAddress: '270 Orchard Road',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '1489,51',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '211,6',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895551,
    supOrderRef: '',
    supOrderId: '619540720X',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 16:23',
    checkInDate: '28.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '22.03.2020 0:00',
    cxlFee: '117,82',
    hotelCountryCode: 'US',
    hotelDestination: 'Montgomery, AL, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/267ACCD8-CE3C-4E93-B883-5CEDE4F7F6D4.jpeg',
    hotelName: 'Candlewood Suites Montgomery North',
    hotelAddress: '9151 Boyd Cooper Pkwy',
    star: 2,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '103,33',
    supplier: 'Bonotel',
    smartbook: '',
    rebooker: '12,15',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895330,
    supOrderRef: 6992341,
    supOrderId: 6949675,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 15:32',
    checkInDate: '05.06.2020',
    checkOutDate: '07.06.2020',
    cxlStart: '30.05.2020 0:00',
    cxlFee: '259,4',
    hotelCountryCode: 'NL',
    hotelDestination: 'Amsterdam, Netherlands',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/05D5BD94-522E-4B38-9674-FECC59574805.jpeg',
    hotelName: 'Olympic Hotel',
    hotelAddress: '12 Ijsbaanpad',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '259,4',
    supplier: 'Carsolize',
    smartbook: '',
    rebooker: '38,05',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6895318,
    supOrderRef: 35742235,
    supOrderId: 31907224,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 15:29',
    checkInDate: '19.06.2020',
    checkOutDate: '21.06.2020',
    cxlStart: '13.06.2020 0:00',
    cxlFee: '733,1',
    hotelCountryCode: 'US',
    hotelDestination: 'Lancaster, PA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/6D5401CF-0924-4E31-BB4B-2EE940B0ED07.jpeg',
    hotelName: 'Eden Resort and Suites BW Premier Collection',
    hotelAddress: '222 Eden Road',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '595,17',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '93,35',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6895239,
    supOrderRef: 3196230102,
    supOrderId: '4,77791E+11',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 15:12',
    checkInDate: '09.04.2020',
    checkOutDate: '11.04.2020',
    cxlStart: '02.04.2020 0:00',
    cxlFee: 362,
    hotelCountryCode: 'US',
    hotelDestination: 'Naples, FL, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/936A790F-B09D-4219-B56C-7E8B38FA6646.jpeg',
    hotelName: 'Hilton Naples',
    hotelAddress: '5111 Tamiami Trail North',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 362,
    supplier: 'HotelsPro',
    smartbook: '',
    rebooker: '30,16',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6895225,
    supOrderRef: '2,7032E+17',
    supOrderId: 'SH9864165',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 15:10',
    checkInDate: '01.08.2020',
    checkOutDate: '06.08.2020',
    cxlStart: '01.07.2020 0:00',
    cxlFee: '865,4',
    hotelCountryCode: 'ES',
    hotelDestination: 'Barcelona, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/EE451841-53C6-4A6D-A0F1-6F9A1E513C44.jpeg',
    hotelName: 'Hotel Garbi Millenni',
    hotelAddress: 'Ronda Sant Pau 14',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '786,73',
    supplier: 'SunHotels',
    smartbook: '',
    rebooker: '71,1',
    sbRbCurrency: 'EUR',
    payment: 'Not Paid',
  },
  {
    segmentId: 6895094,
    supOrderRef: '4BB6SH',
    supOrderId: '2,1032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 14:43',
    checkInDate: '15.06.2020',
    checkOutDate: '19.06.2020',
    cxlStart: '08.06.2020 0:00',
    cxlFee: '102,28',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/780E08D9-1F88-468F-ABF5-77A599659F20.jpeg',
    hotelName: 'Excalibur Hotel & Casino',
    hotelAddress: '3850 Las Vegas Blvd S',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '95,2',
    supplier: 'Escalabeds',
    smartbook: '',
    rebooker: '36,21',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6894784,
    supOrderRef: 'LONF204648',
    supOrderId: 'LONF204648',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 13:17',
    checkInDate: '21.03.2020',
    checkOutDate: '22.03.2020',
    cxlStart: '17.03.2020 0:00',
    cxlFee: '109,33',
    hotelCountryCode: 'US',
    hotelDestination: 'Danvers, MA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/F2B84E88-3B47-45B7-A0BC-2385E5F26700.jpeg',
    hotelName: 'Best Western Plus North Shore Hotel',
    hotelAddress: '50 Dayton St',
    star: 2,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '101,7',
    supplier: 'RTS',
    smartbook: '',
    rebooker: '11,7',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6894758,
    supOrderRef: '102-11078129',
    supOrderId: '1,1032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 13:08',
    checkInDate: '31.08.2020',
    checkOutDate: '03.09.2020',
    cxlStart: '25.08.2020 0:00',
    cxlFee: '215,88',
    hotelCountryCode: 'ES',
    hotelDestination: 'Barcelona, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/079911D4-58EC-459D-9AD0-FE4D230448A7.jpeg',
    hotelName: 'Hotel Ronda House',
    hotelAddress: 'C San Erasme 19',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '215,88',
    supplier: 'Hotelbeds',
    smartbook: '',
    rebooker: '21,83',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6894312,
    supOrderRef: '',
    supOrderId: 'Y4CMIM',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 10:30',
    checkInDate: '08.06.2020',
    checkOutDate: '16.06.2020',
    cxlStart: '30.05.2020 0:00',
    cxlFee: '3892,71',
    hotelCountryCode: 'US',
    hotelDestination: 'Chicago, IL, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2E87E08F-6AD7-4FAD-B6B6-A57E37A082FE.jpeg',
    hotelName: 'Hyatt Regency Chicago',
    hotelAddress: '151 East Wacker Dr',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '3475,63',
    supplier: 'WelcomeBeds',
    smartbook: '',
    rebooker: '436,84',
    sbRbCurrency: 'EUR',
    payment: 'Not Paid',
  },
  {
    segmentId: 6894184,
    supOrderRef: '76-6717887',
    supOrderId: '2,8022E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 9:50',
    checkInDate: '09.04.2020',
    checkOutDate: '13.04.2020',
    cxlStart: '31.03.2020 0:00',
    cxlFee: '534,8',
    hotelCountryCode: 'TR',
    hotelDestination: 'Alanya, Turkey',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/FF506CBE-9D6A-48D5-8D24-60E83C3FDCA2.jpeg',
    hotelName: 'Haydarpasha Palace',
    hotelAddress: 'Türkler Mah.Kargi Çiftlik Alanya 1',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '488,12',
    supplier: 'Hotelbeds',
    smartbook: '',
    rebooker: '43,16',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6894078,
    supOrderRef: 1656756176,
    supOrderId: '9,20054E+12',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 9:08',
    checkInDate: '25.04.2020',
    checkOutDate: '28.04.2020',
    cxlStart: '21.04.2020 0:00',
    cxlFee: '188,72',
    hotelCountryCode: 'FR',
    hotelDestination: 'Saint-Malo, France',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/467678B6-F23E-40BE-816D-A05E4BAC7F70.jpeg',
    hotelName: 'Anne de Bretagne',
    hotelAddress: '10 11 Rue Saint Thomas',
    star: 2,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '179,73',
    supplier: 'Expedia',
    smartbook: '',
    rebooker: '26,07',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893921,
    supOrderRef: 6963511,
    supOrderId: 6920943,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 8:07',
    checkInDate: '20.05.2020',
    checkOutDate: '27.05.2020',
    cxlStart: '13.05.2020 0:00',
    cxlFee: 411,
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/780E08D9-1F88-468F-ABF5-77A599659F20.jpeg',
    hotelName: 'Excalibur Hotel & Casino',
    hotelAddress: '3850 Las Vegas Blvd S',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '357,85',
    supplier: 'Carsolize',
    smartbook: '',
    rebooker: '35,06',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893905,
    supOrderRef: 35627078,
    supOrderId: 31744807,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 8:00',
    checkInDate: '16.03.2020',
    checkOutDate: '19.03.2020',
    cxlStart: '07.03.2020 0:00',
    cxlFee: '350,2',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B82F0F97-D235-44A5-8847-DAC06BCB3371.jpeg',
    hotelName: 'TI Treasure Island Hotel and Casino',
    hotelAddress: '3300 Las Vegas Blvd S',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '290,67',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '35,58',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893840,
    supOrderRef: 272198351,
    supOrderId: 272191259,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 7:35',
    checkInDate: '21.06.2020',
    checkOutDate: '22.06.2020',
    cxlStart: '16.06.2020 0:00',
    cxlFee: '58,3',
    hotelCountryCode: 'LK',
    hotelDestination: 'Ambalangoda, Sri Lanka',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B1DB5DAF-BCD7-476B-B0BD-736049FF3F62.jpeg',
    hotelName: 'Hotel J Ambalangoda',
    hotelAddress: 'No 509 Galle Road',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: 53,
    supplier: 'Agoda',
    smartbook: '',
    rebooker: '17,88',
    sbRbCurrency: 'EUR',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893688,
    supOrderRef: 'SWVPDZ',
    supOrderId: '1,1032E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 6:26',
    checkInDate: '21.03.2020',
    checkOutDate: '23.03.2020',
    cxlStart: '15.03.2020 0:00',
    cxlFee: 294,
    hotelCountryCode: 'US',
    hotelDestination: 'New York City, NY, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D6157139-3E4F-494F-A96D-116BABB0CBB7.jpeg',
    hotelName: 'The Wagner Hotel',
    hotelAddress: '2 West Street',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 294,
    supplier: 'FastPayHotels',
    smartbook: '',
    rebooker: '32,12',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893651,
    supOrderRef: '',
    supOrderId: 'Y4CMIL',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 6:04',
    checkInDate: '14.06.2020',
    checkOutDate: '21.06.2020',
    cxlStart: '07.06.2020 0:00',
    cxlFee: '1935,05',
    hotelCountryCode: 'US',
    hotelDestination: 'San Francisco, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/83B1A129-32EF-438D-8D71-7C07EA3CA753.jpeg',
    hotelName: 'Holiday Inn Golden Gateway',
    hotelAddress: '1500 Van Ness Ave',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1639,87',
    supplier: 'WelcomeBeds',
    smartbook: '',
    rebooker: '349,1',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893498,
    supOrderRef: '',
    supOrderId: 242079,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 5:00',
    checkInDate: '28.03.2020',
    checkOutDate: '30.03.2020',
    cxlStart: '21.03.2020 0:00',
    cxlFee: '375,31',
    hotelCountryCode: 'US',
    hotelDestination: 'Los Angeles, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/1B80F6C4-2BA6-445C-8AE4-95423017EC98.jpeg',
    hotelName: 'Hilton Checkers Los Angeles',
    hotelAddress: '535 South Grand Avenue',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '375,31',
    supplier: 'Nuitee',
    smartbook: '',
    rebooker: '31,33',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893497,
    supOrderRef: 'LONF204447',
    supOrderId: 'LONF204447',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 4:59',
    checkInDate: '14.03.2020',
    checkOutDate: '15.03.2020',
    cxlStart: '09.03.2020 0:00',
    cxlFee: '116,58',
    hotelCountryCode: 'US',
    hotelDestination: 'San Diego, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D9D676E3-EEF3-4D88-B004-DC1F852D07CF.jpeg',
    hotelName: 'Town and Country San Diego',
    hotelAddress: '500 Hotel Circle North',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '116,58',
    supplier: 'RTS',
    smartbook: '',
    rebooker: '13,54',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893488,
    supOrderRef: '9ab3fb76-dc6e-4a93-8f5b-3ae84e39121c',
    supOrderId: 'R1919153332',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 4:55',
    checkInDate: '19.04.2020',
    checkOutDate: '24.04.2020',
    cxlStart: '12.04.2020 0:00',
    cxlFee: '343,85',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/780E08D9-1F88-468F-ABF5-77A599659F20.jpeg',
    hotelName: 'Excalibur Hotel & Casino',
    hotelAddress: '3850 Las Vegas Blvd S',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 317,
    supplier: 'GetARoom',
    smartbook: '',
    rebooker: '160,41',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893332,
    supOrderRef: 6912105,
    supOrderId: 6869806,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 4:00',
    checkInDate: '09.04.2020',
    checkOutDate: '12.04.2020',
    cxlStart: '22.03.2020 0:00',
    cxlFee: '230,81',
    hotelCountryCode: 'DO',
    hotelDestination: 'Puerto Plata, Dominican Republic',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5A7E229B-AE95-4CA5-83A0-4190911D5EC5.jpeg',
    hotelName: 'Playabachata Resort All Inclusive',
    hotelAddress: 'Bahia De Maimon',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '201,6',
    supplier: 'Carsolize',
    smartbook: '',
    rebooker: '33,2',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893150,
    supOrderRef: 30332850,
    supOrderId: 6073996,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:58',
    checkInDate: '03.07.2020',
    checkOutDate: '04.07.2020',
    cxlStart: '26.06.2020 0:00',
    cxlFee: '133,22',
    hotelCountryCode: 'US',
    hotelDestination: 'Lone Pine, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5CE73997-6C2F-4509-9045-78F2EA5036C1.jpeg',
    hotelName: 'Best Western Plus Frontier',
    hotelAddress: '1008 S Main St',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '133,22',
    supplier: 'AmericanToursInternational',
    smartbook: '',
    rebooker: '30,78',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6893073,
    supOrderRef: 30314927,
    supOrderId: 6065487,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:30',
    checkInDate: '27.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '14.03.2020 0:00',
    cxlFee: '280,41',
    hotelCountryCode: 'US',
    hotelDestination: 'North Conway, NH, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/81D26EA5-BA96-45E9-8FBF-71B3F3CBFB4D.jpeg',
    hotelName: 'North Conway Grand Hotel',
    hotelAddress: '72 Common Court',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '244,21',
    supplier: 'AmericanToursInternational',
    smartbook: '',
    rebooker: '45,21',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893055,
    supOrderRef: 35703892,
    supOrderId: 31825844,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:26',
    checkInDate: '27.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: '391,31',
    hotelCountryCode: 'US',
    hotelDestination: 'Bloomington, MN, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5355181E-FAE9-483D-9F63-1B18F2287690.jpeg',
    hotelName: 'Radisson Blu Mall of America',
    hotelAddress: '2100 Killebrew Drive',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '339,36',
    supplier: 'Hotusa',
    smartbook: '8,91',
    rebooker: '57,95',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893043,
    supOrderRef: 35703889,
    supOrderId: 31825840,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:23',
    checkInDate: '27.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: '391,31',
    hotelCountryCode: 'US',
    hotelDestination: 'Bloomington, MN, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5355181E-FAE9-483D-9F63-1B18F2287690.jpeg',
    hotelName: 'Radisson Blu Mall of America',
    hotelAddress: '2100 Killebrew Drive',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '339,36',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '66,86',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893035,
    supOrderRef: 35703887,
    supOrderId: 31825838,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:20',
    checkInDate: '27.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: '391,31',
    hotelCountryCode: 'US',
    hotelDestination: 'Bloomington, MN, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5355181E-FAE9-483D-9F63-1B18F2287690.jpeg',
    hotelName: 'Radisson Blu Mall of America',
    hotelAddress: '2100 Killebrew Drive',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '339,36',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '66,86',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6893028,
    supOrderRef: 271965031,
    supOrderId: 271957987,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 2:18',
    checkInDate: '17.04.2020',
    checkOutDate: '21.04.2020',
    cxlStart: '07.04.2020 0:00',
    cxlFee: '872,73',
    hotelCountryCode: 'US',
    hotelDestination: 'Orlando, FL, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/8F8E88AD-0366-43EA-AF1C-2F7C724E4EA7.jpeg',
    hotelName: 'Hilton Orlando Bonnet Creek Resort',
    hotelAddress: '14100 Bonnet Creek Resort Lane',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 746,
    supplier: 'Agoda',
    smartbook: '',
    rebooker: '205,24',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892825,
    supOrderRef: '',
    supOrderId: 'RO08201/01',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 1:23',
    checkInDate: '26.03.2020',
    checkOutDate: '31.03.2020',
    cxlStart: '19.03.2020 0:00',
    cxlFee: '198,77',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/616867EC-D8D9-4927-99F6-254F1A492A5B.jpeg',
    hotelName: 'The STRAT Hotel Casino and Skypod',
    hotelAddress: '2000 South Las Vegas Boulevard',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '198,77',
    supplier: 'Travco',
    smartbook: '',
    rebooker: '16,8',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6892826,
    supOrderRef: '256-5050523',
    supOrderId: '3,03202E+16',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 1:23',
    checkInDate: '26.03.2020',
    checkOutDate: '31.03.2020',
    cxlStart: '16.03.2020 0:00',
    cxlFee: '216,69',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/616867EC-D8D9-4927-99F6-254F1A492A5B.jpeg',
    hotelName: 'The STRAT Hotel Casino and Skypod',
    hotelAddress: '2000 South Las Vegas Boulevard',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '216,69',
    supplier: 'Hotelbeds',
    smartbook: '',
    rebooker: '58,34',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892810,
    supOrderRef: '',
    supOrderId: 'DHB200228084919924',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 1:18',
    checkInDate: '02.05.2020',
    checkOutDate: '05.05.2020',
    cxlStart: '22.04.2020 0:00',
    cxlFee: '279,01',
    hotelCountryCode: 'SG',
    hotelDestination: 'Singapore, Singapore',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2AA8386B-10F8-4C9A-BA29-4C6D50CE9D20.jpeg',
    hotelName: 'V Hotel Bencoolen',
    hotelAddress: '48 Bencoolen Street',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '279,01',
    supplier: 'DidaTravel',
    smartbook: '',
    rebooker: '167,3',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892772,
    supOrderRef: 74768920,
    supOrderId: 74768920,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '27.02.2020 1:07',
    checkInDate: '29.06.2020',
    checkOutDate: '03.07.2020',
    cxlStart: '19.06.2020 0:00',
    cxlFee: '733,09',
    hotelCountryCode: 'MX',
    hotelDestination: 'Playa Del Carmen, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/F92FE76D-717E-4F16-A431-FA4EFAE57779.jpeg',
    hotelName: 'Grand Palladium White Sand Resort & Spa All Inclusive',
    hotelAddress: 'Carr Federal Chetumal - Puerto Juarez',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '733,09',
    supplier: 'HotelDo',
    smartbook: '',
    rebooker: '339,98',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892510,
    supOrderRef: 35720487,
    supOrderId: 31846120,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 23:55',
    checkInDate: '23.09.2020',
    checkOutDate: '28.09.2020',
    cxlStart: '16.09.2020 0:00',
    cxlFee: '1006,84',
    hotelCountryCode: 'US',
    hotelDestination: 'Monterey, CA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/EF458704-1B54-4548-9E20-DC60938EFD73.jpeg',
    hotelName: 'Monterey Tides',
    hotelAddress: '2600 Sand Dunes Dr',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: 903,
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '106,32',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892400,
    supOrderRef: 35732583,
    supOrderId: 31863574,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 23:29',
    checkInDate: '07.07.2020',
    checkOutDate: '08.07.2020',
    cxlStart: '01.07.2020 0:00',
    cxlFee: '165,2',
    hotelCountryCode: 'US',
    hotelDestination: 'St. Louis, MO, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/C2E285F2-6EAB-48B7-B846-5F17C3E06DCA.jpeg',
    hotelName: 'Moonrise Hotel',
    hotelAddress: '6177 Delmar In The Loop 6177',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '153,34',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '31,06',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6892356,
    supOrderRef: '2,7022E+17',
    supOrderId: 'YAC/18047433',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 23:20',
    checkInDate: '28.10.2020',
    checkOutDate: '31.10.2020',
    cxlStart: '17.10.2020 0:00',
    cxlFee: '184,48',
    hotelCountryCode: 'ES',
    hotelDestination: 'Salou, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/ADE66080-98C4-4D54-AAC1-24931F8DE4E7.jpeg',
    hotelName: '4R Playa Park',
    hotelAddress: 'C Vendrell 1 3',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '184,48',
    supplier: 'Yalago',
    smartbook: '',
    rebooker: '112,46',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892269,
    supOrderRef: 35723283,
    supOrderId: 31849878,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 22:54',
    checkInDate: '11.05.2020',
    checkOutDate: '15.05.2020',
    cxlStart: '04.05.2020 0:00',
    cxlFee: '1194,89',
    hotelCountryCode: 'MX',
    hotelDestination: 'Playa Del Carmen, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/93563AE5-AAD1-439A-8F0F-8014B0C63980.jpeg',
    hotelName: 'Grand Hyatt Playa Del Carmen Resort',
    hotelAddress: '1A Avenida Esquina Calle 26',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1194,89',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '125,64',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6892246,
    supOrderRef: 'ac773d94-b4c9-42e3-9085-69df662f85d2',
    supOrderId: 722378631,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 22:47',
    checkInDate: '15.04.2020',
    checkOutDate: '17.04.2020',
    cxlStart: '09.04.2020 0:00',
    cxlFee: 126,
    hotelCountryCode: 'GB',
    hotelDestination: 'Saint Helier, United Kingdom',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/0CDB05E8-E2CF-4EFB-83C8-C9F198BDDF83.jpeg',
    hotelName: 'The Inn Boutique Jersey',
    hotelAddress: 'Queens Road',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: 126,
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '134,75',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6892124,
    supOrderRef: 30328295,
    supOrderId: 6071725,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 22:16',
    checkInDate: '23.03.2020',
    checkOutDate: '29.03.2020',
    cxlStart: '15.03.2020 0:00',
    cxlFee: '989,66',
    hotelCountryCode: 'US',
    hotelDestination: 'Boston, MA, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/ECEB08C4-569C-4C72-BDE8-B12CC801A92B.jpeg',
    hotelName: 'Studio Allston Hotel',
    hotelAddress: '1234 Soldiers Field Rd',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '894,06',
    supplier: 'AmericanToursInternational',
    smartbook: '',
    rebooker: '272,06',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6892111,
    supOrderRef: 'HTL-AE2-245226975',
    supOrderId: 245226975,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 22:13',
    checkInDate: '01.06.2020',
    checkOutDate: '04.06.2020',
    cxlStart: '24.05.2020 0:00',
    cxlFee: '115,23',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/11DCC89E-8C6B-4F02-A72A-CACB1C00AE3A.jpeg',
    hotelName: 'Sahara Las Vegas',
    hotelAddress: '2535 Las Vegas Blvd S',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '107,16',
    supplier: 'DOTW',
    smartbook: '',
    rebooker: '43,18',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6892016,
    supOrderRef: 1226073,
    supOrderId: 1647766,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 21:47',
    checkInDate: '09.04.2020',
    checkOutDate: '10.04.2020',
    cxlStart: '05.04.2020 0:00',
    cxlFee: '126,38',
    hotelCountryCode: 'US',
    hotelDestination: 'Houston, TX, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/8A78F27B-6A59-47EF-B0D8-CE45E9CEF440.jpeg',
    hotelName: 'Wyndham Houston Medical Center Hotel and Suites',
    hotelAddress: '6800 Main Street',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '126,38',
    supplier: 'Olympia',
    smartbook: '',
    rebooker: '31,44',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6892008,
    supOrderRef: 'dKjserRBDXktM0ey',
    supOrderId: 'GRN-202004-295916',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 21:46',
    checkInDate: '09.07.2020',
    checkOutDate: '10.07.2020',
    cxlStart: '01.07.2020 0:00',
    cxlFee: '318,42',
    hotelCountryCode: 'IS',
    hotelDestination: 'Oraefi, Iceland',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/0FE4CB04-01A4-4122-8CC9-A9F8CF755261.jpeg',
    hotelName: 'Fosshotel Glacier Lagoon',
    hotelAddress: 'Hnappavellir',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 277,
    supplier: 'GRNconnect',
    smartbook: '',
    rebooker: 87,
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6891961,
    supOrderRef: 'QZ44RD',
    supOrderId: '8,03202E+16',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 21:37',
    checkInDate: '27.03.2020',
    checkOutDate: '30.03.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: 469,
    hotelCountryCode: 'US',
    hotelDestination: 'New York City, NY, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/6D8BA044-5EF3-4CBB-940B-FCA9FC1015AC.jpeg',
    hotelName: 'Millennium Hilton New York Downtown',
    hotelAddress: '55 Church Street',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 469,
    supplier: 'World2Meet',
    smartbook: '',
    rebooker: '50,63',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6891967,
    supOrderRef: 6928841,
    supOrderId: 6886400,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 21:37',
    checkInDate: '30.03.2020',
    checkOutDate: '02.04.2020',
    cxlStart: '22.03.2020 0:00',
    cxlFee: '365,73',
    hotelCountryCode: 'CA',
    hotelDestination: 'Montreal, QC, Canada',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2E212B47-2F78-4F5D-9AA6-325E45D43865.jpeg',
    hotelName: 'DoubleTree By Hilton Montreal',
    hotelAddress: '1255 Jeanne Mance Street',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'USD',
    totalAmount: '365,73',
    supplier: 'Carsolize',
    smartbook: '',
    rebooker: '49,46',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6891801,
    supOrderRef: 'TL74073407',
    supOrderId: 'TL74073407',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 20:55',
    checkInDate: '07.05.2020',
    checkOutDate: '14.05.2020',
    cxlStart: '27.04.2020 0:00',
    cxlFee: '1762,39',
    hotelCountryCode: 'US',
    hotelDestination: 'Honolulu, HI, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/BF76EE0C-FBAD-4C1D-8929-A8E280843FDE.jpeg',
    hotelName: 'Hyatt Centric Waikiki Beach',
    hotelAddress: '349 Seaside Avenue Honolulu Hi 96815',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1762,39',
    supplier: 'Travellanda',
    smartbook: '',
    rebooker: '374,84',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6891635,
    supOrderRef: '2,7022E+17',
    supOrderId: 'YAC/18047425',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 20:17',
    checkInDate: '13.04.2020',
    checkOutDate: '20.04.2020',
    cxlStart: '05.04.2020 0:00',
    cxlFee: '840,82',
    hotelCountryCode: 'ES',
    hotelDestination: 'Port De Pollenca, Spain',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/BCEB2126-9E48-4833-9B90-5DA5327BA474.jpeg',
    hotelName: 'Puerto Azul Suite Hotel',
    hotelAddress: 'C Pere Melia S N',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '840,82',
    supplier: 'Yalago',
    smartbook: '',
    rebooker: '394,61',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6891621,
    supOrderRef: 35738542,
    supOrderId: 31902751,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 20:14',
    checkInDate: '17.06.2020',
    checkOutDate: '19.06.2020',
    cxlStart: '28.05.2020 0:00',
    cxlFee: '412,09',
    hotelCountryCode: 'DE',
    hotelDestination: 'Munich, Germany',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/C755EDE9-EEFA-4F5D-8262-DB884D4AA334.jpeg',
    hotelName: 'Classik Hotel Martinshof',
    hotelAddress: 'Martin Empl Ring 8',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 375,
    supplier: 'Hotusa',
    smartbook: '-0,4',
    rebooker: '301,37',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6891447,
    supOrderRef: 35737174,
    supOrderId: 31898986,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 19:26',
    checkInDate: '16.05.2020',
    checkOutDate: '17.05.2020',
    cxlStart: '08.05.2020 0:00',
    cxlFee: '195,56',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/1A5D93DB-0A35-48FC-A8E3-815A8AACF0B2.jpeg',
    hotelName: 'Golden Nugget Las Vegas Hotel & Casino',
    hotelAddress: '129 Fremont St',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '195,56',
    supplier: 'Hotusa',
    smartbook: '',
    rebooker: '133,69',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6891414,
    supOrderRef: 'LONF207228',
    supOrderId: 'LONF207228',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 19:18',
    checkInDate: '28.03.2020',
    checkOutDate: '31.03.2020',
    cxlStart: '20.03.2020 0:00',
    cxlFee: '137,24',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/524D46FA-94E3-4D01-BD7F-7905EA878083.jpeg',
    hotelName: 'OYO Hotel and Casino Las Vegas',
    hotelAddress: '115 East Tropicana Avenue',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '137,24',
    supplier: 'RTS',
    smartbook: '',
    rebooker: '54,24',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6891404,
    supOrderRef: '104a088f-6e96-45c1-8a06-981c35181fe8|R1908087333',
    supOrderId: 9204407118,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 19:15',
    checkInDate: '13.03.2020',
    checkOutDate: '15.03.2020',
    cxlStart: '07.03.2020 0:00',
    cxlFee: '115,82',
    hotelCountryCode: 'FR',
    hotelDestination: 'Paris, France',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/74155266-CA56-4F8E-9AA1-3EDC982E071C.jpeg',
    hotelName: 'Exelmans',
    hotelAddress: '73, Rue Boileau',
    star: 2,
    cancelationPolicy: 'Full',
    status: 'OK',
    currency: 'EUR',
    totalAmount: '115,82',
    supplier: 'HotelsPro',
    smartbook: '',
    rebooker: '26,3',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
  {
    segmentId: 6891291,
    supOrderRef: 1230491,
    supOrderId: 1658784,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 18:48',
    checkInDate: '29.05.2020',
    checkOutDate: '01.06.2020',
    cxlStart: '21.05.2020 0:00',
    cxlFee: '199,85',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/1A5D93DB-0A35-48FC-A8E3-815A8AACF0B2.jpeg',
    hotelName: 'Golden Nugget Las Vegas Hotel & Casino',
    hotelAddress: '129 Fremont St',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '199,85',
    supplier: 'Olympia',
    smartbook: '',
    rebooker: '27,48',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6891278,
    supOrderRef: '',
    supOrderId: 'Y4CIVR',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 18:43',
    checkInDate: '26.03.2020',
    checkOutDate: '30.03.2020',
    cxlStart: '18.03.2020 0:00',
    cxlFee: '266,54',
    hotelCountryCode: 'US',
    hotelDestination: 'Las Vegas, NV, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/524D46FA-94E3-4D01-BD7F-7905EA878083.jpeg',
    hotelName: 'OYO Hotel and Casino Las Vegas',
    hotelAddress: '115 East Tropicana Avenue',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '246,28',
    supplier: 'WelcomeBeds',
    smartbook: '',
    rebooker: '79,37',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6891184,
    supOrderRef: '27P44J',
    supOrderId: '8,03202E+16',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 18:21',
    checkInDate: '24.04.2020',
    checkOutDate: '28.04.2020',
    cxlStart: '16.04.2020 0:00',
    cxlFee: '450,53',
    hotelCountryCode: 'US',
    hotelDestination: 'Lyndhurst, NJ, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/D3132EEB-4A6F-4884-B17F-4D45FA614F41.jpeg',
    hotelName: 'Courtyard by Marriott Lyndhurst Meadowlands',
    hotelAddress: '1 Polito Avenue',
    star: 3,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 446,
    supplier: 'LotsOfHotels',
    smartbook: '-0,45',
    rebooker: '40,72',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6889633,
    supOrderRef: 271285947,
    supOrderId: 271278959,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 11:06',
    checkInDate: '28.03.2020',
    checkOutDate: '04.04.2020',
    cxlStart: '25.03.2020 0:00',
    cxlFee: '10700,02',
    hotelCountryCode: 'GB',
    hotelDestination: 'London, United Kingdom',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2767568F-21BD-4F5B-80B2-384BF8B204B9.jpeg',
    hotelName: 'Four Seasons Hotel London at Park Lane',
    hotelAddress: 'Hamilton Place Park Lane',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: '10700,02',
    supplier: 'Agoda',
    smartbook: '',
    rebooker: '1836,29',
    sbRbCurrency: 'EUR',
    payment: 'Paid',
  },
  {
    segmentId: 6888738,
    supOrderRef: 'e5e0a0e2-7a54-46be-8b94-6628bc42177c',
    supOrderId: 936032256,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 5:15',
    checkInDate: '16.04.2020',
    checkOutDate: '22.04.2020',
    cxlStart: '09.04.2020 0:00',
    cxlFee: 684,
    hotelCountryCode: 'NO',
    hotelDestination: 'Oslo, Norway',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/926D1396-941D-4595-8AE6-4C476855E548.jpeg',
    hotelName: 'Comfort Hotel Grand Central',
    hotelAddress: 'Jernbanetorget 1',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: 684,
    supplier: 'RateHawk',
    smartbook: '',
    rebooker: '737,91',
    sbRbCurrency: 'DKK',
    payment: 'Not Paid',
  },
  {
    segmentId: 6888368,
    supOrderRef: '2,6022E+17',
    supOrderId: 'SH9780598',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '26.02.2020 3:10',
    checkInDate: '20.04.2020',
    checkOutDate: '24.04.2020',
    cxlStart: '11.04.2020 0:00',
    cxlFee: '1918,25',
    hotelCountryCode: 'JM',
    hotelDestination: 'Montego Bay, Jamaica',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/03FE2D23-3A28-4A95-8031-9CE36076AB4B.jpeg',
    hotelName: 'Iberostar Grand Rose Hall Adults Only All Inclusive',
    hotelAddress: 'Rose Hall Main Road',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '1618,78',
    supplier: 'SunHotels',
    smartbook: '239,42',
    rebooker: '129,36',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6874464,
    supOrderRef: '',
    supOrderId: 'Y4CLTC',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '22.02.2020 22:55',
    checkInDate: '30.04.2020',
    checkOutDate: '04.05.2020',
    cxlStart: '18.04.2020 0:00',
    cxlFee: '3515,9',
    hotelCountryCode: 'MX',
    hotelDestination: 'Puerto Vallarta, Mexico',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/8588FB91-98CF-4566-8ACD-63286776437B.jpeg',
    hotelName: 'Secrets Vallarta Bay Resort & SPA Adults Only',
    hotelAddress: 'David Alfaro Siqueiros No.164 Zona Hotelera Las Glorias',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 2967,
    supplier: 'WelcomeBeds',
    smartbook: '251,96',
    rebooker: '1085,24',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6845960,
    supOrderRef: 36,
    supOrderId: '2,02002E+17',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '16.02.2020 22:25',
    checkInDate: '13.08.2020',
    checkOutDate: '16.08.2020',
    cxlStart: '04.08.2020 0:00',
    cxlFee: '1054,91',
    hotelCountryCode: 'HR',
    hotelDestination: 'Dubrovnik, Croatia',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/57953389-C64E-4B44-A33B-62D4243FFAEC.jpeg',
    hotelName: 'Dubrovnik Palace',
    hotelAddress: 'Masarykov Put 20',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '877,58',
    supplier: 'OTSGlobe',
    smartbook: '112,22',
    rebooker: '40,27',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6817885,
    supOrderRef: 6841985,
    supOrderId: 6800335,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '11.02.2020 2:54',
    checkInDate: '29.03.2020',
    checkOutDate: '01.04.2020',
    cxlStart: '01.03.2020 0:00',
    cxlFee: '2436,26',
    hotelCountryCode: 'MV',
    hotelDestination: 'Male, Maldives',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/52F80106-CEBE-4865-8AA7-DC46EFDAA7BA.jpeg',
    hotelName: 'Conrad Maldives Rangali Island',
    hotelAddress: 'Rangali Island',
    star: 5,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: 2108,
    supplier: 'Carsolize',
    smartbook: '125,45',
    rebooker: '87,75',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6816462,
    supOrderRef: 35730979,
    supOrderId: 31861210,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '10.02.2020 21:29',
    checkInDate: '14.07.2020',
    checkOutDate: '18.07.2020',
    cxlStart: '03.07.2020 0:00',
    cxlFee: '2268,2',
    hotelCountryCode: 'CA',
    hotelDestination: 'Quebec, QC, Canada',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/2F135FF3-7999-4C7D-A9BF-DD6182C94285.jpeg',
    hotelName: 'Fairmont Le Chateau Frontenac',
    hotelAddress: '1 Rue Des Carrieres',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '2268,2',
    supplier: 'Hotusa',
    smartbook: '198,8',
    rebooker: '384,84',
    sbRbCurrency: 'USD',
    payment: 'Not Paid',
  },
  {
    segmentId: 6684033,
    supOrderRef: 'LONF206169',
    supOrderId: 'LONF206169',
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '17.01.2020 2:05',
    checkInDate: '07.05.2020',
    checkOutDate: '10.05.2020',
    cxlStart: '21.04.2020 0:00',
    cxlFee: '850,99',
    hotelCountryCode: 'BS',
    hotelDestination: 'Nassau, Bahamas',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/B4B16880-A42A-4EEF-82FF-ECEF9336199B.jpeg',
    hotelName: 'Grand Hyatt Baha Mar',
    hotelAddress: 'One Baha Mar Boulevard',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'USD',
    totalAmount: '723,9',
    supplier: 'RTS',
    smartbook: '80,58',
    rebooker: '30,32',
    sbRbCurrency: 'USD',
    payment: 'Paid',
  },
  {
    segmentId: 6587968,
    supOrderRef: 'HTL-AE2-244757375',
    supOrderId: 244757375,
    priceOverTimeGraph: '(Graph)',
    creationDateProperty: '01.01.2020 16:11',
    checkInDate: '03.04.2020',
    checkOutDate: '05.04.2020',
    cxlStart: '28.03.2020 0:00',
    cxlFee: 250,
    hotelCountryCode: 'US',
    hotelDestination: 'Weston, FL, United States',
    hotelImage: 'https://az712897.vo.msecnd.net/images/full/5F8D4897-5A49-4B02-8C4E-B57D8D4911D1.jpeg',
    hotelName: 'Bonaventure Resort and Spa',
    hotelAddress: '250 Racquet Club Road',
    star: 4,
    cancelationPolicy: 'Full',
    status: 'CX',
    currency: 'EUR',
    totalAmount: 250,
    supplier: 'DOTW',
    smartbook: '168,28',
    rebooker: '27,58',
    sbRbCurrency: 'DKK',
    payment: 'Paid',
  },
];
